import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-cuerpo',
    templateUrl: './cuerpo.component.html',
    styleUrls: ['./cuerpo.component.scss']
})
export class CuerpoComponent implements OnInit {
    public route: string;
    public slickOptions: any = {
        slidesToShow: 1,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        responsive: [],
    };


    constructor(private _route: Router) {
        this.route = _route.url.slice(1);
        this.route = this.route.split('?')[0];
        // console.log('La ruta es: ', this.route);
    }

    ngOnInit() {
    }

}
